export enum ScheduleType {
  MEASURE = 'pomiar',
  MONTAGE = 'montaż',
  VISIT = 'wizyta',
  OTHER = 'inne',
}
